/**
 * Polyfills para Safari 12 / iOS 12 compatibility
 * Este ficheiro DEVE ser importado ANTES de qualquer outra dependência.
 */

// 1. Polyfill performance.measure() - Safari 12 não suporta a API moderna
//    com objeto de opções. React 19 usa performance.measure(name, { start, detail })
//    que causa "The string did not match the expected pattern" no Safari 12.
if (typeof performance !== 'undefined' && performance.measure) {
  var origMeasure = performance.measure.bind(performance);
  performance.measure = function () {
    try {
      return origMeasure.apply(performance, arguments);
    } catch (e) {
      return undefined;
    }
  };
}

// 2. Polyfill performance.mark() - mesma precaução para Safari 12
if (typeof performance !== 'undefined' && performance.mark) {
  var origMark = performance.mark.bind(performance);
  performance.mark = function () {
    try {
      return origMark.apply(performance, arguments);
    } catch (e) {
      return undefined;
    }
  };
}

// 3. Polyfill queueMicrotask - não disponível em Safari 12
if (typeof queueMicrotask !== 'function') {
  window.queueMicrotask = function (callback) {
    Promise.resolve()
      .then(callback)
      .catch(function (e) {
        setTimeout(function () {
          throw e;
        });
      });
  };
}

// 4. Polyfill globalThis - não disponível em Safari 12
if (typeof globalThis === 'undefined') {
  if (typeof window !== 'undefined') {
    window.globalThis = window;
  }
}

// 5. Polyfill structuredClone - não disponível em Safari < 15.4
if (typeof structuredClone !== 'function') {
  window.structuredClone = function (obj) {
    return JSON.parse(JSON.stringify(obj));
  };
}

// 6. Polyfill AbortController - parcialmente disponível em Safari 12.0 (completo em 12.1)
if (typeof AbortController === 'undefined') {
  window.AbortController = function () {
    this.signal = { aborted: false };
    this.abort = function () {
      this.signal.aborted = true;
    };
  };
}
